<template>
  <div class="engine">
    <svg class="engine__icon">
      <use xlink:href="#svg-magnifying"></use>
    </svg>
    <input
      :placeholder="params.placeholder"
      type="text"
      class="engine__input"
      @click="handleOpen($event)"
      @input="handlerInput($event)"
      @keyup.enter="goSearchCatalog"
    />
    <transition name="fade">
      <div v-if="isOpenResult && items && openItems" class="engine__result" @wheel.prevent>
        <PerfectScrollbar class="engine__scroll">
          <SearchEngineTopResponse :result="result" />
        </PerfectScrollbar>
        <div v-if="result && result.messages" class="engine-all">
          <DefButtonPrimary :href="result.url">
            {{ result.messages.allResults }}
          </DefButtonPrimary>
        </div>
      </div>
      <div v-else-if="result && result.messages" class="engine__result engine__result_nothing">
        {{ result.messages.nothingFound }}
        "<b class="search-engine-top__value">{{ value }}</b
        >"
      </div>
    </transition>
  </div>
</template>

<script>
import SearchEngineTopResponse from '@components/Search/SearchEngineTop/SearchEngineTopResponse.vue';
import DefButtonPrimary from '@components/Def/DefButtonPrimary/DefButtonPrimary.vue';

export default {
  name: 'Engine',
  components: { DefButtonPrimary, SearchEngineTopResponse },
  props: {
    params: {
      type: Object,
      default: () => ({
        ajax: {
          url: '/ajax.php',
          data: {
            action: 'search',
            ajax: 'y',
            lang: 'ru',
            q: 'safd',
          },
          searchName: 'q',
          delay: 100,
        },
        placeholder: 'Поиск',
      }),
    },
  },
  data() {
    return {
      result: {},
      value: '',
      openItems: false,
      abortController: null,
    };
  },
  computed: {
    isOpenResult() {
      return !!this.result?.products?.items?.length;
    },
    items() {
      return this.result?.products?.items;
    },
  },
  methods: {
    handlerInput(e) {
      this.value = e.target.value;

      if (this.abortController) {
        this.abortController.abort();
        this.abortController = null;
      }

      this.getSearchElements();
    },
    async getSearchElements() {
      try {
        this.abortController = new AbortController();
        const { params } = this;

        if (params?.ajax?.url && params?.ajax?.searchName && this.value !== '') {
          const { data } = params.ajax;
          data[params.ajax.searchName] = this.value;
          const response = await axios.get(params.ajax.url, {
            params: data,
            signal: this.abortController?.signal,
          });
          this.result = response.data;
          this.openItems = true;
        } else {
          this.result = {};
        }
      } catch (err) {
        console.error(err);
      }
    },
    handleOpen() {
      if (this.value === '') this.result = {};
      this.openItems = !this.openItems;

      if (this.openItems) {
        document.addEventListener('click', this.handlerAnotherClick);
      } else {
        document.removeEventListener('click', this.handlerAnotherClick);
      }
    },
    handlerAnotherClick({ target }) {
      const parent = target.closest('.engine');

      if (!parent) {
        this.openItems = false;
        document.removeEventListener('click', this.handlerAnotherClick);
      }
    },
    goSearchCatalog({ target }) {
      // console.log(this.result.url, target.value);
      if (this.result.url) {
        window.location.href = this.result.url;
      } else {
        window.location.search = `?q=${target.value}`;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.engine {
  display: flex;
  align-items: center;
  border-bottom: 1px solid var(--background-black);
  width: 100%;
  position: relative;
  padding: 10px 0;
  &__input {
    flex-grow: 1;
    border: unset;
    background-color: transparent;
    font-weight: 500;
    font-size: 16px;
    line-height: 100%;
    ::placeholder {
      color: #5f5f67;
    }
  }
  &__icon {
    width: 20px;
    height: 20px;
    margin-right: 16px;
  }

  &__result {
    position: absolute;
    width: 100%;
    background-color: #f6f6f6;
    z-index: 2;
    top: calc(100% + 1px);
    border: 1px solid #cacece;
    &_nothing {
      padding: 16px;
      line-height: 24px;
      @include point-md {
        padding: 24px;
      }
      @include point-lg {
        padding: 24px 36px;
      }
    }
  }
  &__scroll {
    position: relative;
    max-height: 400px;
    overflow-y: auto;
    padding: 0 16px;
    @include point-md {
      padding: 0 24px;
    }
    @include point-lg {
      padding: 0 36px;
    }
  }
  :deep(.search-engine-top-response) {
    margin-top: 10px;
    @include point-md {
      display: block;
    }
  }
}
.engine-all {
  padding: 16px;
  @include point-md {
    padding: 16px 24px;
  }
  @include point-lg {
    padding: 16px 36px;
  }
}
</style>
